import { Button } from './Button';
import styles from './NotificationModal.module.css';

interface NotificationModalProps {
  visible: boolean;
  title: string;
  body: string;
  onDismiss: () => void;
}

export function NotificationModal({ visible, title, body, onDismiss }: NotificationModalProps) {
  if (!visible) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.dialog}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.body}>{body}</p>
        <div className={styles.buttonRow}>
          <Button onClick={onDismiss}>OK</Button>
        </div>
      </div>
    </div>
  );
}

export default NotificationModal;
